// redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import gamesReducer from "./gamesSlice"
import ipsReducer from "./ipSlice"
import authReducer from "./authSlice"
import incapacityReducer from "./incapacitySlice"
import vacationReducer from "./vacationSlice"
import newsletterReducer from "./newsletterSlice"
import adminReducer from "./adminSlice"
import marketingReducer from "./marketingSlice"

export const store = configureStore({
  reducer: {
    ips: ipsReducer,
    games: gamesReducer,
    auth: authReducer,
    incapacity: incapacityReducer,
    vacation: vacationReducer,
    newsletter: newsletterReducer,
    admin: adminReducer,
    marketing: marketingReducer,
  },
});
